import { jwtDecode } from "jwt-decode";
import config from "../config.js";
import http from "./httpService.js";

export function getCurrentUserId() {
  let token = localStorage.getItem("access_token");
  if (!token) {
    return null;
  }
  const user = jwtDecode(token);
  return user[
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
  ];
}

export function getCurrentUserRole() {
  let token = localStorage.getItem("access_token");
  if (!token) {
    return null;
  }
  const user = jwtDecode(token);
  return user["Role"];
}
export function getCurrentUserName() {
  let token = localStorage.getItem("access_token");
  if (!token) {
    return null;
  }
  const user = jwtDecode(token);
  return user["Name"];
}

export function checkUserPermission(permission) {
  let token = localStorage.getItem("access_token");
  if (!token) {
    return false;
  }
  const user = jwtDecode(token);

  return user["AccessPages"].includes(permission);
}

export function sendUserInfo(user) {
  return http.post(`${config.apiUrl}/Account/Login`, user);
}

export const getToken = () => {
  let accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    let token = jwtDecode(accessToken);
    if (token) {
      return token;
    }
  }
  return null;
};
